module.exports = __webpack_public_path__ + "img/background.bc658397.png";